<script>
   /*************************************************************/
   /* EigenvaluesPlot                                           */
   /* --------------------                                      */
   /* shows plot with eigenavalues vs. number of PCs            */
   /*************************************************************/

   import { Axes, XAxis, YAxis, Box } from 'svelte-plots-basic/2d';
   import { Vector } from 'mdatools/arrays';

   import { PNG_WIDTH, PNG_HEIGHT, PNG_RES, MARGINS, FACE_COLORS } from '../../../shared/plots/Defaults.js';
   import { pcamodel_get } from '../../../shared/wasm/dist/pca.js';
   import PlotSeries from '../../../shared/plots/PlotSeries.svelte';

   export let params;                     // JSON with main plot parameters
   export let model;                      // JSON with model object

   export let showGrid = true;
   export let fileName = 'plot-eigenvalues';
   export let pngWidth = PNG_WIDTH;
   export let pngHeight = PNG_HEIGHT;
   export let pngRes = PNG_RES;


   /*****************************************/
   /* Component code                        */
   /*****************************************/

   // constant plot parameters
   const xLabel = 'Number of PCs';
   const title = 'Eigenvalues';
   const yLabels = {'none': 'λ', 'log':  'log(λ)', 'sqrt': 'sqrt(λ)'};
   let transform = 'none';
   let plotType = 'b';
   let showLabels = 'hide';


   function f(values, transform) {
      if (transform === 'none') return values;
      if (transform === 'log') return values.apply(v => Math.log(v))
      if (transform === 'sqrt') return values.apply(v => Math.sqrt(v))
   }

   // reactive expressions to monitor changes in plot parameters
   $: if (params && params.transform !== transform) transform = params.transform;
   $: if (params && params.plotType !== plotType) plotType = params.plotType;
   $: if (params && params.showLabels !== showLabels) showLabels = params.showLabels;

   // reactive computation of y limits

   $: eigenvalues = model ? new Vector(pcamodel_get(model, 'eigenvals')) : null;
   $: xValues = model ? Vector.seq(1, model.ncomp) : null;
   $: yValues = eigenvalues ? f(eigenvalues, transform) : null;
   $: labels = yValues ? Array.from(yValues.v).map(v => v.toFixed(v < 0.1 ? 3 : 2)) : null;
   $: limX = model ? [1 - model.ncomp / 15, model.ncomp + model.ncomp / 20] : [0, 1];

   $: minY = yValues ? (transform === 'none' ? 0 : yValues.v[model.ncomp - 1]) : 0;
   $: maxY = yValues ? yValues.v[0] : 1;
   $: dY = (maxY - minY) / 18;
   $: limY = yValues ? [minY - dY, maxY +  dY] : null;
   $: yLabel = yLabels[transform];
</script>

{#if model && xValues && yValues }
<Axes {title} {xLabel} {yLabel} {limX} {limY}
   {fileName} {pngWidth} {pngHeight} {pngRes}
   downloadLinks="hover"
   margins={MARGINS}
>
   <slot name="before"></slot>

   <!-- data points  -->
   <PlotSeries
      {xValues}
      {yValues}
      {plotType}
      {showLabels}
      {labels}
      faceColor={FACE_COLORS['cal']}
      lineWidth={1.5}
      seriesTitle="variance"
   />


   <XAxis {showGrid} slot="xaxis" whole={true} />
   <YAxis {showGrid} slot="yaxis" />
   <Box slot="box" />
</Axes>{/if}